<template>
  <div>
    <v-card elevation="0" class="pb-2 rounded-lg">
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-2">
          <h5 class="ma-0">Públicos-alvo</h5>
          <v-btn color="primary" small @click="openDialog()">
            <v-icon small left>mdi-plus</v-icon>
            Novo público-alvo
          </v-btn>
        </div>

        <v-alert v-if="error" type="error" class="mb-3">
          {{ error }}
        </v-alert>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          dense
          hide-details
          outlined
          class="mb-3"
        />

        <v-data-table
          :loading="loading"
          :items="audiences"
          :headers="headers"
          :search="search"
          class="elevation-0"
        >
          <template v-slot:item.icon="{ item }">
            <v-icon>{{ item.icon }}</v-icon>
          </template>
          <template v-slot:item.description="{ item }">
            <span class="text-truncate d-inline-block" style="max-width: 280px">
              {{ item.description || "—" }}
            </span>
          </template>
          <template v-slot:item.active="{ item }">
            <v-chip small :color="item.active ? 'success' : 'grey'" dark label>
              {{ item.active ? "Ativo" : "Inativo" }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="openDialog(item)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="removeAudience(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </div>
    </v-card>

    <FeatureAudienceDialog @success="loadAudiences" />
  </div>
</template>

<script>
import featureAudiencesService from "@/services/ultimate/featureAudiences";
import FeatureAudienceDialog from "@/components/ultimate/feature/FeatureAudienceDialog.vue";

export default {
  name: "FeatureAudiences",
  components: { FeatureAudienceDialog },
  metaInfo: { title: "Públicos-alvo" },
  data() {
    return {
      loading: false,
      error: null,
      search: "",
      audiences: [],
      headers: [
        { text: "Nome", value: "name" },
        { text: "Ícone", value: "icon", sortable: false },
        { text: "Descrição", value: "description" },
        { text: "Ordem", value: "sortOrder" },
        { text: "Status", value: "active" },
        { text: "Ações", value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    openDialog(audience = null) {
      this.$root.$emit("feature-audience-modal", audience);
    },
    async loadAudiences() {
      try {
        this.loading = true;
        this.error = null;
        const response = await featureAudiencesService.getAll();
        this.audiences = response.audiences || [];
      } catch (error) {
        this.error = error.message || "Erro ao buscar públicos-alvo";
      } finally {
        this.loading = false;
      }
    },
    async removeAudience(audience) {
      if (!confirm(`Remover o público-alvo "${audience.name}"?`)) return;
      try {
        await featureAudiencesService.remove(audience.id);
        await this.loadAudiences();
      } catch (error) {
        this.error = error.message || "Erro ao remover público-alvo";
      }
    },
  },
  mounted() {
    this.loadAudiences();
  },
};
</script>
